import { FelteSubmitError } from './error.js';

function createDefaultSubmitHandler(form) {
    if (!form)
        return;
    return async function onSubmit() {
        let body = new FormData(form);
        const action = new URL(form.action);
        const method = form.method.toLowerCase() === 'get'
            ? 'get'
            : action.searchParams.get('_method') || form.method;
        let enctype = form.enctype;
        if (form.querySelector('input[type="file"]')) {
            enctype = 'multipart/form-data';
        }
        if (method === 'get' || enctype === 'application/x-www-form-urlencoded') {
            body = new URLSearchParams(body);
        }
        let fetchOptions;
        if (method === 'get') {
            body.forEach((value, key) => {
                action.searchParams.append(key, value);
            });
            fetchOptions = { method, headers: { Accept: 'application/json' } };
        }
        else {
            fetchOptions = {
                method,
                body,
                headers: Object.assign(Object.assign({}, (enctype !== 'multipart/form-data' && {
                    'Content-Type': enctype,
                })), { Accept: 'application/json' }),
            };
        }
        const response = await window.fetch(action.toString(), fetchOptions);
        if (response.ok)
            return response;
        throw new FelteSubmitError('An error occurred while submitting the form', response);
    };
}

export { createDefaultSubmitHandler };
//# sourceMappingURL=default-submit-handler.js.map
